import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { userMailInteractionAction } from 'owa-mail-actions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { onMailSearchComplete } from 'owa-mail-actions/lib/mailSearchActions';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TriagePatterns" */ './lazyIndex')
);

export { default as getUserInteractionContext } from './utils/getUserInteractionContext';

export function registerTriagePatternsOrchestrators() {
    if (isFeatureEnabled('tri-triagePattern')) {
        registerLazyOrchestrator(
            userMailInteractionAction,
            lazyModule,
            m => m.triagePatternsOrchestrator
        );
        registerLazyOrchestrator(
            onMailSearchComplete,
            lazyModule,
            m => m.triagePatternsOrchestratorForSearch
        );
    }
}
